var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list-table',{attrs:{"url":"users/userlist","title":"لیست مشترکین","detailUrl":"clientdetails","viewUrl":"viewclientdetails","fields":_vm.fields,"params":_vm.params}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }